import React, { Component } from 'react';
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import ConsultationForm from './SConsultationForm';
class ConsultationApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Schedule Consultation"/>
          <ConsultationForm/>
          <Footer />
        </div>
    );
  }
}

export default ConsultationApp;
